import {
  competitionBoards,
  disciplineForSection,
  type CompetitionBoard,
  type CompetitionDiscipline,
  type Discipline,
} from '@structural-climbing/validation'
import type { CompetitionStandingEntry, CompetitionStandingsData } from './types'

/**
 * The rows on one board. A single-discipline competition has exactly one
 * board, so nothing is filtered there, which also keeps the page working
 * against a Worker that predates `discipline` on a standing.
 *
 * General is bouldering plus lead. It arrives already summed and ranked, in
 * its own list, because adding up two lists that were each cut to a limit
 * would get a large category wrong.
 */
export function boardEntries(
  data: Pick<CompetitionStandingsData, 'standings' | 'generalStandings'> | null | undefined,
  competition: CompetitionDiscipline,
  board: CompetitionBoard,
): CompetitionStandingEntry[] {
  const entries = data?.standings ?? []
  if (competitionBoards(competition).length < 2) return entries
  if (board === 'general') return data?.generalStandings ?? []
  return entries.filter((e) => e.discipline === board)
}

/**
 * The discipline a route is graded and scored in. In a combined competition
 * the route's own section decides, by the same rule the standings RPC uses.
 */
export function routeBoard(
  competition: CompetitionDiscipline,
  sectionDiscipline: string | null | undefined,
): Discipline {
  return competition === 'combined' ? disciplineForSection(sectionDiscipline) : competition
}
